import { isNativeApp } from '@/lib/native';

/** Auslieferungskanal des Frontends: öffentliche Website vs. native iPad-App. */
export type Channel = 'web' | 'app';

/**
 * SSOT der Kanal-Erkennung (CLAUDE.md „Kanal-Architektur"). App-Kanal, wenn
 * EINE Quelle zutrifft:
 *  - Capacitor-Bridge injiziert (echte Shell, Remote-URL-Modus), ODER
 *  - UA-Marker „SizilianerApp" (capacitor.config.ts → ios.appendUserAgent).
 *    Nötig als Fallback, weil Playwright den User-Agent setzen kann, aber
 *    keine Capacitor-Bridge injiziert — sonst wäre der Kanal-Guard nicht
 *    testbar.
 *
 * Bewusst KEIN dritter PWA-Kanal — standalone/Home-Screen bleibt ein
 * Push-Detail in usePushSubscription. Kanal-Weichen NIE direkt über
 * navigator.userAgent oder isNativeApp() bauen, immer hierüber.
 */
export function isAppChannel(): boolean {
  if (isNativeApp()) return true;
  return typeof navigator !== 'undefined' && navigator.userAgent.includes('SizilianerApp');
}

export function getChannel(): Channel {
  return isAppChannel() ? 'app' : 'web';
}

/**
 * Läuft dieses Frontend im Kontor-WebView von DER PASS? (2.6a)
 *
 * Der Kontor ist das Web-Backoffice, das in der nativen App in einem
 * WKWebView steckt. Er ist KEIN dritter Kanal, und das ist Absicht:
 *
 *  - `Channel` bleibt `'web' | 'app'`. Ein dritter Wert liefe in
 *    `resolveFeature()` still auf „default an", weil die
 *    `channel_flags`-Schlüssel nur `{web, app}` kennen — jedes
 *    abgeschaltete Kanal-Feature wäre im Kontor plötzlich wieder da.
 *
 *  - Der WebView trägt BEIDE Marker im User-Agent
 *    (`SizilianerApp SizilianerKontor`), damit `isAppChannel()` weiter
 *    `true` liefert. Sonst griffe der `PublicRoute`-Guard nicht, und ein
 *    Fehl-Tipp landete über den Catch-all auf der öffentlichen Website —
 *    mitten in der App.
 *
 * Diese Funktion beantwortet deshalb nur eine Zusatzfrage („bin ich im
 * WebView?"), sie ersetzt die Kanal-Erkennung nicht.
 */
export function isKontorChannel(): boolean {
  return typeof navigator !== 'undefined' && navigator.userAgent.includes('SizilianerKontor');
}
